export const languages = [
  {
    name: "JavaScript",
    mimes: [
      "text/javascript",
      "text/ecmascript",
      "application/javascript",
      "application/x-javascript",
      "application/ecmascript",
    ],
    mode: "javascript",
    ext: ["js"],
    alias: ["ecmascript", "js", "node"],
  },
  { name: "Java", mime: "text/x-java", mode: "clike", ext: ["java"] },
  {
    name: "JSON",
    mimes: ["application/json", "application/x-json"],
    mode: "javascript",
    ext: ["json", "map"],
    alias: ["json5"],
  },
  {
    name: "Shell",
    mimes: ["text/x-sh", "application/x-sh"],
    mode: "shell",
    ext: ["sh", "ksh", "bash"],
    alias: ["bash", "sh", "zsh"],
    file: /^PKGBUILD$/,
  },
  {
    name: "HTML",
    mime: "text/html",
    mode: "htmlmixed",
    ext: ["html", "htm", "handlebars", "hbs"],
    alias: ["xhtml"],
  },
  {
    name: "Plain Text",
    mime: "text/plain",
    mode: "null",
    ext: ["txt", "text", "conf", "def", "list", "log"],
  },
  { name: "C", mime: "text/x-csrc", mode: "clike", ext: ["c", "h", "ino"] },
  {
    name: "C++",
    mime: "text/x-c++src",
    mode: "clike",
    ext: ["cpp", "c++", "cc", "cxx", "hpp", "h++", "hh", "hxx"],
    alias: ["cpp"],
  },
  {
    name: "C#",
    mime: "text/x-csharp",
    mode: "clike",
    ext: ["cs"],
    alias: ["csharp"],
  },
  { name: "CSS", mime: "text/css", mode: "css", ext: ["css"] },
  {
    name: "Dart",
    mimes: ["application/dart", "text/x-dart"],
    mode: "dart",
    ext: ["dart"],
  },
  { name: "Elm", mime: "text/x-elm", mode: "elm", ext: ["elm"] },
  { name: "Go", mime: "text/x-go", mode: "go", ext: ["go"] },
  {
    name: "Groovy",
    mime: "text/x-groovy",
    mode: "groovy",
    ext: ["groovy", "gradle"],
    file: /^Jenkinsfile$/,
  },
  { name: "HTTP", mime: "message/http", mode: "http" },
  { name: "JSX", mime: "text/jsx", mode: "jsx", ext: ["jsx"] },
  { name: "Kotlin", mime: "text/x-kotlin", mode: "clike", ext: ["kt"] },
  {
    name: "LaTeX",
    mime: "text/x-latex",
    mode: "stex",
    ext: ["text", "ltx", "tex"],
    alias: ["tex"],
  },
  { name: "Lua", mime: "text/x-lua", mode: "lua", ext: ["lua"] },
  {
    name: "Markdown",
    mime: "text/x-markdown",
    mode: "markdown",
    ext: ["markdown", "md", "mkd"],
  },
  {
    name: "Nginx",
    mime: "text/x-nginx-conf",
    mode: "nginx",
    file: /nginx.*\.conf$/i,
  },
  {
    name: "Objective-C",
    mime: "text/x-objectivec",
    mode: "clike",
    ext: ["m", "mm"],
    alias: ["objective-c", "objc"],
  },
  { name: "Perl", mime: "text/x-perl", mode: "perl", ext: ["pl", "pm"] },
  {
    name: "PHP",
    mimes: [
      "text/x-php",
      "application/x-httpd-php",
      "application/x-httpd-php-open",
    ],
    mode: "php",
    ext: ["php", "php3", "php4", "php5", "php7", "phtml"],
  },
  {
    name: "PowerShell",
    mime: "application/x-powershell",
    mode: "powershell",
    ext: ["ps1", "psd1", "psm1"],
  },
  {
    name: "Python",
    mime: "text/x-python",
    mode: "python",
    ext: ["BUILD", "bzl", "py", "pyw"],
    file: /^(BUCK|BUILD)$/,
  },
  {
    name: "R",
    mime: "text/x-rsrc",
    mode: "r",
    ext: ["r", "R"],
    alias: ["rscript"],
  },
  {
    name: "Ruby",
    mime: "text/x-ruby",
    mode: "ruby",
    ext: ["rb"],
    alias: ["jruby", "macruby", "rake", "rb", "rbx"],
  },
  { name: "Sass", mime: "text/x-sass", mode: "sass", ext: ["sass"] },
  { name: "Scala", mime: "text/x-scala", mode: "clike", ext: ["scala"] },
  { name: "SQL", mime: "text/x-sql", mode: "sql", ext: ["sql"] },
  { name: "Stylus", mime: "text/x-styl", mode: "stylus", ext: ["styl"] },
  {
    name: "TypeScript",
    mime: "text/typescript",
    mode: "text/typescript",
    ext: ["ts"],
  },
  { name: "Swift", mime: "text/x-swift", mode: "swift", ext: ["swift"] },
  {
    name: "Vue.js Component",
    mimes: ["script/x-vue", "text/x-vue"],
    mode: "vue",
    ext: ["vue"],
  },
  {
    name: "XML",
    mimes: ["application/xml", "text/xml"],
    mode: "xml",
    ext: ["xml", "xsl", "xsd", "svg"],
    alias: ["rss", "wsdl", "xsd"],
  },
  {
    name: "YAML",
    mimes: ["text/x-yaml", "text/yaml"],
    mode: "yaml",
    ext: ["yaml", "yml"],
    alias: ["yml"],
  },
  { name: "PlantUML", mode: "plantuml" },
];

const modeMap = {};
languages.forEach(({ name, mime, mode }) => {
  if (mode === "clike" || mode === "sql") {
    modeMap[name.toLowerCase()] = Array.isArray(mime) ? mime[0] : mime;
  } else {
    modeMap[name.toLowerCase()] = mode;
  }
});

export function getMode(language) {
  return modeMap[(language || "").toLowerCase()] || "null";
}
